<template>
  <div class="main2-content">
    <div class="panel-content">
      <div class="layout-flex">
        <div
          class="menu"
          v-for="(item, index) in menu"
          :key="index"
          :style="{
            background: index == btnIndex ? item.color : '',
          }"
          @click="handleMenu(index)"
        >
          <div><img class="img" :src="item.to" /></div>
          <div class="name">{{ item.name }}</div>
          <div class="nameEn">{{ item.nameEn }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config1";
export default {
  components: {},
  data() {
    return {
      ...config,
      btnIndex: 0,
      activeNames: 0,
      activeNames1: 0,
      activeNames2: 0,
      activeNames3: 0,
      menu: [
        {
          name: "良好健康与福祉",
          nameEn: "Good Health and Well-being",
          to: require("../../assets/csr/imgsMobile/MiconG@2x.png"),
          color: "#7fb572",
        },
        {
          name: "优质教育",
          nameEn: "Quality Education",
          to: require("../../assets/csr/imgsMobile/MiconQ@2x.png"),
          color: "#c4202e",
        },
        {
          name: "清洁饮水和卫生设施",
          nameEn: "Clean Water and Sanitation",
          to: require("../../assets/csr/imgsMobile/MiconC@2x.png"),
          color: "#50bec5",
        },
        {
          name: "经济适用的清洁能源",
          nameEn: "Affordable and Clean Energy",
          to: require("../../assets/csr/imgsMobile/MiconA@2x.png"),
          color: "#F9C213",
        },
        {
          name: "体面工作和经济增长",
          nameEn: "Decent Work and Economic Growth",
          to: require("../../assets/csr/imgsMobile/MiconD@2x.png"),
          color: "#a11c44",
        },
        {
          name: "产业、创新和基础设施",
          nameEn: "Industry, Innovation and Infrastructure",
          to: require("../../assets/csr/imgsMobile/MiconI@2x.png"),
          color: "#e1b253",
        },
        {
          name: "可持续城市和社区",
          nameEn: "Sustainable Cities and Communities",
          to: require("../../assets/csr/imgsMobile/MiconS@2x.png"),
          color: "#5fb66e",
        },
        {
          name: "负责任消费和生产",
          nameEn: "Responsible Consumption and Production",
          to: require("../../assets/csr/imgsMobile/MiconR@2x.png"),
          color: "#e19b40",
        },
        {
          name: "促进目标实现的伙伴关系",
          nameEn: "Partnerships for the Goal",
          to: require("../../assets/csr/imgsMobile/MiconP@2x.png"),
          color: "#3b9bbb",
        },
      ],
      scene1: 0,
      scene2: 0,
      scene3: 0,
      scene4: 0,
      scene5: 0,
      scene6: 0,
      scene7: 0,
      scene8: 0,
      scene9: 0,
    };
  },
  computed: {},
  beforeMount() {},
  mounted() {},
  methods: {
    layoutShow(val = 0) {
      if (val == this.btnIndex) {
        return true;
      } else {
        return false;
      }
    },
    handleMenu(index) {
      this.btnIndex = index;
      this.$parent.btnIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./commonMobile.less");
.layout-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
  height: 250px;
  padding: 30px 10px;
}
.menu {
  width: 115px;
  height: 80px;
  background: #bbbbbb;
  color: #ffffff;
  text-align: center;
  font-size: 9px;
  .img {
    width: 29px;
    height: 24px;
    margin-top: 10px;
  }
}
</style>
